import { render, staticRenderFns } from "./adminBanner.vue?vue&type=template&id=ae918724&"
import script from "./adminBanner.vue?vue&type=script&lang=js&"
export * from "./adminBanner.vue?vue&type=script&lang=js&"
import style0 from "./adminBanner.vue?vue&type=style&index=0&id=ae918724&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports